import React from "react";
import { useCart } from "../../context/CartContext";

export default function ReplaceCartPopup() {

  const {
    showReplacePopup,
    confirmReplaceCart,
    cancelReplaceCart
  } = useCart();

  if (!showReplacePopup) return null;

  return (

    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal fade show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >

        <div className="modal-dialog modal-dialog-centered">

          <div className="modal-content rounded-4 shadow">

            <div className="modal-header">

              <h5 className="modal-title text-danger fw-bold">
                Replace Cart?
              </h5>

              <button
                className="btn-close"
                onClick={cancelReplaceCart}
              ></button>

            </div>

            <div className="modal-body text-center">

              Your cart contains items from another lab.
              <br />
              Replace the cart?

            </div>

            <div className="modal-footer justify-content-center gap-3">

              <button
                className="btn btn-outline-secondary"
                onClick={cancelReplaceCart}
              >
                No
              </button>

              <button
                className="btn btn-danger"
                onClick={confirmReplaceCart}
              >
                Yes Replace
              </button>

            </div>

          </div>

        </div>

      </div>
    </>

  );

}